/**
 * WooCommerce My Account page block markup (shortcode block).
 */
export const WOOCOMMERCE_ACCOUNT_BLOCK_HTML = String.raw`[woocommerce_my_account]`;
